<div class="container-full" style="margin-top:10px;">
    <app-header-title-lot-data style="margin-top:10px;"
        [title]="'Aging Report'"
        [lotNumber]="_appGeneralState.currentLotNumber"
        [lotName]="_appGeneralState.currentLotName"
    ></app-header-title-lot-data>
    
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 700px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>
                <form 
                (ngSubmit)="onSubmitAsOfAgingSentence()" 
                novalidate
                [formGroup]="asOfAgingForm" 
                style="margin-top:20px;">
            <div class="row" style="width:100%;">
                <div class="col-6">
                    <mat-form-field style="width:100%;color:gray">
                        <mat-label>Choose the "As Of" date</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="asOfDate">
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                </div>
                <div class="col-1">
                    <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="!asOfAgingForm.valid">Search</button>
                    <!-- <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" (click)="exportButtonHandler()">Export</button> -->
                </div>
            </div>
        </form>



<ng-container *ngIf="this.agingReportList.length > 0">
    <div style="margin-top:30px;"></div>
    <div class="ace-heading-text-secondary" style="font-size:21px;margin-left:10px;margin-bottom:10px;">
        Number of Invoices: {{agingReportList.length - 1}}    

        @if(showPinnedRow == false){
            <button mat-button (click)="gridAgingReport.pinRow(agingReportList[agingReportList.length - 1].invoiceNumber);togglePinnedRow()" style="margin-left:10px;">
                Show Totals on First Row
            </button>
        }
        @else 
        {
            <button mat-button (click)="gridAgingReport.unpinRow(agingReportList[agingReportList.length - 1].invoiceNumber);togglePinnedRow()" style="margin-left:10px;">
                Show Totals on Last Row
            </button>
        }

    </div>
    <igx-grid #gridAgingReport id="gridAgingReport" [igxPreventDocumentScroll]="true" [data]="agingReportList" [pinning]='pinningConfig' [height]="'720px'" [width]="'100%'" [autoGenerate]="false"
    [primaryKey]="'invoiceNumber'" [cellSelection]="'none'" [rowEditable]="false">

    <igx-column field="lotNumber" header="Lot No."  width="125px" [sortable]="true"></igx-column>
<igx-column field="parkerPayType" header="Type"  width="105px" [sortable]="true"></igx-column>
<igx-column field="customerName" header="Customer Name" width="200px" [sortable]="true" ></igx-column>
<igx-column field="invoiceNumber" header="Invoice Number" width="150px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            
                @if(value == 'Totals')
                {
                    <div style="display:inline-block;text-align: right;width:125px;">
                    <strong>{{value}}:</strong>
                    </div>
                }
                @else {
                    <a href="" (click)="onDisplayInvoice(cell.row.data.invoiceNumber, cell.row.data.lotNumber, cell.row.data.entityId); $event.preventDefault()" style="color:#1976d2;text-decoration:underline;cursor:pointer;">
                        {{cell.value}}
                    </a>
                }
                
        </div>
    </ng-template>
</igx-column>
<igx-column field="theDueDate" header="Due Date" width="140px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            @if(cell.row.data.invoiceNumber == 'Totals'){
                <strong>{{value}}</strong>
            }
            @else {
                {{value}}
            }
        </div>
    </ng-template>
</igx-column>
<igx-column field="current" header="Current" width="125px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            @if(cell.row.data.invoiceNumber == 'Totals'){
                <strong>{{ value | currency}}</strong>
            }
            @else {
                @if(value !== '0001-01-01T00:00:00'){
                    {{ value | currency}}
                }
            }
        </div>
    </ng-template>
</igx-column>
<igx-column field="zone1" header="1-30" width="115px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            @if(cell.row.data.invoiceNumber == 'Totals'){
                <strong>{{ value | currency}}</strong>
            }
            @else {
                @if(value !== '0001-01-01T00:00:00'){
                    {{ value | currency}}
                }
            }
        </div>
    </ng-template>
</igx-column>
<igx-column field="zone2" header="31-60" width="115px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            @if(cell.row.data.invoiceNumber == 'Totals'){
                <strong>{{ value | currency}}</strong>
            }
            @else {
                @if(value !== '0001-01-01T00:00:00'){
                    {{ value | currency}}
                }
            }
        </div>
    </ng-template>
</igx-column>
<igx-column field="zone3" header="61-90" width="115px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            @if(cell.row.data.invoiceNumber == 'Totals'){
                <strong>{{ value | currency}}</strong>
            }
            @else {
                @if(value !== '0001-01-01T00:00:00'){
                    {{ value | currency}}
                }
            }
        </div>
    </ng-template>
</igx-column>
<igx-column field="zone4" header="91-120" width="125px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            @if(cell.row.data.invoiceNumber == 'Totals'){
                <strong>{{ value | currency}}</strong>
            }
            @else {
                @if(value !== '0001-01-01T00:00:00'){
                    {{ value | currency}}
                }
            }
        </div>
    </ng-template>
</igx-column>
<igx-column field="zone5" header="Over" width="115px" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            @if(cell.row.data.invoiceNumber == 'Totals'){
                <strong>{{ value | currency}}</strong>
            }
            @else {
                @if(value !== '0001-01-01T00:00:00'){
                    {{ value | currency}}
                }
            }
        </div>
    </ng-template>
</igx-column>
<igx-column field="comments" header="Comments" required [sortable]="true" >
    <ng-template igxCell let-value let-cell="cell">
            <div class="row" style="width:100%;margin-top:20px;">
                <div class="col-10">
                    {{cell.row.data.comments}}
                </div>
                <div class="col-2">
                    <button style="position:relative;top: -10px;" mat-icon-button aria-label="Edit Comments" [matTooltip]="'Add/Update Comments'" (click)="onEditComments(cell.row.data.invoiceNumber, cell.row.data.commentsOnly)">
                        <mat-icon>edit</mat-icon>
                      </button>
                </div>
            </div>
    </ng-template>
</igx-column>

<igx-grid-toolbar>
<igx-grid-toolbar-actions>
<igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
<igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
<igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
</igx-grid-toolbar-actions>
</igx-grid-toolbar>

<!-- <igx-action-strip #actionStrip1>
    <igx-grid-pinning-actions></igx-grid-pinning-actions>
    <igx-grid-editing-actions></igx-grid-editing-actions>
</igx-action-strip> -->

</igx-grid>


</ng-container>

</mat-card-content>
<mat-card-actions style="margin-top:20px;">
    
</mat-card-actions>

</mat-card>                                                                             

</div>
